import { render, staticRenderFns } from "./PayItem.vue?vue&type=template&id=ea3ef1f4&scoped=true&"
import script from "./PayItem.vue?vue&type=script&lang=js&"
export * from "./PayItem.vue?vue&type=script&lang=js&"
import style0 from "./PayItem.vue?vue&type=style&index=0&id=ea3ef1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3ef1f4",
  null
  
)

export default component.exports